// extracted by mini-css-extract-plugin
export default {"wrapper":"te","wrap":"ue"};